import { logger } from '@libs/core';

import { CWEA_ENDPOINTS } from '../constants';
import { cweaClient } from '../clients/api-proxy-browser-client';

/*
  For SSR
    - Returns basic product information ONLY
    - Should be called from the server side to get general information
    - Param - Web Style ID or SKU
 */
export type GetProductBase = {
    id: string;
};

export async function getProductBase<T>({ id }: GetProductBase): Promise<T | null> {
    const url = CWEA_ENDPOINTS.product.getProductBase(id);
    logger.info(`[GET PRODUCT BASE]: ${url}`);

    return await cweaClient.get(url);
}
